module.exports = __webpack_public_path__ + "static/media/hand.4215aaa7.svg";